import { render } from "./KsefCompanyCertCreate.vue?vue&type=template&id=1facce29&scoped=true"
import script from "./KsefCompanyCertCreate.vue?vue&type=script&lang=js"
export * from "./KsefCompanyCertCreate.vue?vue&type=script&lang=js"

import "./KsefCompanyCertCreate.vue?vue&type=style&index=0&id=1facce29&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1facce29"]])

export default __exports__